import { render, staticRenderFns } from "./SittingIcon.vue?vue&type=template&id=9f46107e"
import script from "./SittingIcon.vue?vue&type=script&lang=js"
export * from "./SittingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports